import { get } from 'lodash'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import { SUBCATEGORIES } from 'constants/layout/setup-activity'

export default function(fields) {
  const errors = {
    ...fields,
    helpers: undefined,
    activityCategory: {}
  }

  if (get(fields, 'helpers.subcategory') === SUBCATEGORIES.others.value) {
    errors.activityCategory = {
      activitySection: {
        value: ACTIVITY_SECTIONS.residential_project.id
      },
      parent: {
        id: get(fields, 'helpers.category')
      },
      userDefined: true,
      name: get(fields, 'helpers.others')
    }
  } else {
    errors.activityCategory.id = get(fields, 'helpers.subcategory')
  }

  return errors
}
